import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileSecurityLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/file/file_security_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5858 2C14.1162 2 14.6249 2.21071 15 2.58579L19.4142 7C19.7893 7.37507 20 7.88378 20 8.41421V13H18V10H13.5C12.6716 10 12 9.32843 12 8.5V4H6V20H12V22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H13.5858ZM17.3162 14.0513L20.3162 15.0513C20.7246 15.1874 21 15.5696 21 16V17.6714C21 19.8862 19.3347 21.7467 17.1335 21.9913C17.0448 22.0012 16.9552 22.0012 16.8665 21.9913C14.6653 21.7467 13 19.8862 13 17.6714V16C13 15.5696 13.2754 15.1874 13.6838 15.0513L16.6838 14.0513C16.889 13.9829 17.111 13.9829 17.3162 14.0513ZM17 16.0541L15 16.7208V17.6714C15 18.8376 15.8552 19.8219 17 19.9922C18.1448 19.8219 19 18.8376 19 17.6714V16.7208L17 16.0541ZM14 4.41421V8H17.5858L14 4.41421Z"
		})
	})
});
export default SvgFileSecurityLine;
